import { SoundManagementRepository } from '../data/sound-management-repository';
import { CopySoundsResult } from '../types/sound-management-types';

export class CopySoundsUseCase {
  constructor(private readonly repository: SoundManagementRepository) {}

  async execute(
    newLanguageCode: string,
    baseLanguageCode: string
  ): Promise<CopySoundsResult> {
    return this.repository.copySounds(newLanguageCode, baseLanguageCode);
  }
}
